import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { openDialog, closeDialog } from './actions'

function mapDispatchToState(dispatch) {
    return bindActionCreators({ openDialog, closeDialog }, dispatch)
}

export default (InnerComponent) => {
    @connect(null, mapDispatchToState)
    class hocDialog extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }

    return hocDialog
}
